import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLocationDot,
  faEnvelope,
  faMapLocationDot,
} from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
  const [email, setEmail] = useState('');

  useEffect(() => {
    const user = 'aparnawesternmeadows';
    const domain = 'gmail.com';
    setEmail(`${user}@${domain}`);
  }, []);

  return (
    <div className="support-card">
      {/* Header Section */}
      <div className="d-flex align-items-center mb-3">
        <FontAwesomeIcon
          icon={faLocationDot}
          className="support-card-icon me-2"
        />
        <h3 className="mb-0">Address & Location</h3>
      </div>
      <p className="text-muted">
        Aparna Western Meadows is located near Mokila in a well-connected yet
        peaceful residential area close to Hyderabad.
      </p>

      {/* Address Details */}
      <div className="support-step mb-4">
        <div className="mb-2">
          <strong>Aparna Western Meadows</strong>
        </div>
        <div className="text-muted">
          Kondakal, Shankarpally, K.V. Rangareddy, Telangana - 501 203
        </div>
        {email && (
          <div className="mt-2">
            <FontAwesomeIcon icon={faEnvelope} className="support-step-icon" />
            <a href={`mailto:${email}`} className="text-decoration-none">
              {email}
            </a>
          </div>
        )}
      </div>

      {/* Map Section */}
      <div className="mb-3">
        <div className="d-flex align-items-center mb-3">
          <FontAwesomeIcon
            icon={faMapLocationDot}
            className="support-card-icon me-2"
          />
          <h4 className="mb-0">Location Map</h4>
        </div>
        <div className="map-container">
          <iframe
            className="w-100 h-100"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15225.191094403923!2d78.19149935688476!3d17.445456208646835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbee8ebce2b2d5%3A0x127c86397b453b15!2sAparna%20Western%20Meadows!5e0!3m2!1sen!2sin!4v1737221621517!5m2!1sen!2sin"
            loading="lazy"
            allowFullScreen
            title="Aparna Western Meadows Map"
            style={{ border: 0 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
